let shoppingCartNumber = 0;
let user = [];
let name = '';
let userType = -1;//0员工 1客户
let id = 0;
let cmpId= {cmp:0}//公司id
let buyType = 1;//1件数 2数量 0全部
let customerState = "";
let rank = 3;

let unit = '双';
let pack = '件';

let useinstall = "0";//启用客户安装地址 1启用0不启用

let showProductPrice = true;//显示商品价格
let showTable = true;
let goodsSelect = {};
let cid = 0;//员工默认选择的客户ID

export default{
    shoppingCartNumber,
    user,
    name,
    userType,
    rank,
    id,
    cmpId,
    buyType,
    showProductPrice,
    showTable,
    goodsSelect,
    cid,
    unit,
    pack,
    customerState,
    useinstall,
}